import { render, staticRenderFns } from "./IconArrowheadLeft.vue?vue&type=template&id=48b09d6b&"
import script from "./IconArrowheadLeft.vue?vue&type=script&lang=js&"
export * from "./IconArrowheadLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports